// @helpers
const apiURLBuilder = require('core/apiURLBuilder');
const moment = require('moment');

// @utilities
const { APIPost } = require('utilities/APIRequestHelper');
const { getIbansAccounts } = require('utilities/expensesByCategories/accountsUtilities');
const { getNumberCard } = require('utilities/expensesByCategories/cardsUtilities');

// @constants
const { DATE_FORMAT_API } = require('constants/index');

const {
  CATEGORIES_SUMMARY_BOX_FETCHING,
  CATEGORIES_SUMMARY_BOX_SUCCESS,
  CATEGORIES_SUMMARY_BOX_FAILURE,
} = require('constants/actionTypes');
const { CUSTOM_ACCOUNTS, ALL_ACCOUNTS } = require('constants/expensesByCategories/filters');

const requestCategoriesSummaryFetching = () => {
  return {
    type: CATEGORIES_SUMMARY_BOX_FETCHING,
  };
};

const requestCategoriesSummarySuccess = response => {
  return {
    type: CATEGORIES_SUMMARY_BOX_SUCCESS,
    payload: {
      data: Array.isArray(response) ? response : [],
    },
  };
};

const requestCategoriesSummaryFailure = () => {
  return {
    type: CATEGORIES_SUMMARY_BOX_FAILURE,
  };
};

const requestCategoriesSummary = (isCompareView, isCustom) => (dispatch, getState) => {
  const url = apiURLBuilder.getURL('globalExpensesTotals');
  const immCards = getState().cards;
  const immCreditCards = getState().cards;
  const immAccounts = getState().accounts;
  let fromData = moment().startOf('month');
  if (isCompareView) {
    fromData = fromData.subtract(1, 'month');
  }
  const typeAccount = isCustom ? CUSTOM_ACCOUNTS : ALL_ACCOUNTS;

  const requestData = {
    header: {
      version: 2,
    },
    query: {
      cards: getNumberCard(immCards, immCreditCards, typeAccount),
      ibans: getIbansAccounts(immAccounts, typeAccount),
      from: fromData.format(DATE_FORMAT_API),
      to: moment().format(DATE_FORMAT_API),
      banks: null,
    },
  };

  dispatch(requestCategoriesSummaryFetching());

  return APIPost(dispatch, url, requestData).then(
    response => {
      dispatch(requestCategoriesSummarySuccess(response));
    },
    () => {
      dispatch(requestCategoriesSummaryFailure());
    }
  );
};

module.exports = {
  requestCategoriesSummary,
};
